var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deliveriesStatusByManifest"},[(_vm.loading)?_c('div',{staticClass:"p-3"},_vm._l((8),function(i){return _c('b-skeleton',{key:i,attrs:{"height":"100"}})}),1):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }